import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import React, { useEffect, useState } from 'react'
import { useInvoice, usePut, useCurrent } from '../../hooks/'
import { MwButton, MwSpinnerButton } from '../../components/ui'
import { useDispatch } from 'react-redux'
import { updateSettings } from '../../store/settingSlice'
import SettingListItem from '../../components/settings/SettingListItem'
import { useTranslation } from 'react-i18next'

const CENTRAL_SETTINGS_SCOPE = 'global';

const PurchasesInvoiceSettings = ({ refreshTenant, filterDefineSetting }) => {
    const dispatch = useDispatch();
    const [t] = useTranslation('global')
    const { SETTING_INVOICE } = useInvoice()
    const [invSetting, setInvSetting] = useState(SETTING_INVOICE)
    const { data, loading, putData } = usePut()
    const { currentCompanyId, currentTenantId, currentLangId, currentSettings } = useCurrent();

    const invSettingArray = Object.entries(invSetting || {});
    const invSettingList = invSettingArray.map(([settingName, settingValue]) => (
        <SettingListItem
            key={settingName}
            settingName={settingName}
            settingValue={settingValue}
            filterDefineSetting={filterDefineSetting}
            setGeneralSetting={setInvSetting}
            generalSetting={invSetting}
            currentLangId={currentLangId}
            prefixLang='invoice'
        />
    ));

    useEffect(() => {
        if (data) {
            refreshTenant();
        }
    }, [data, refreshTenant]);

    useEffect(() => {
        if (SETTING_INVOICE) {
            setInvSetting(SETTING_INVOICE);
        }
    }, [SETTING_INVOICE]);

    const saveHandler = async () => {
        try {
            const payload = {
                tenantId: currentTenantId,
                companyId: currentCompanyId,
                scope: CENTRAL_SETTINGS_SCOPE,
                data: {
                    invoiceSettings: invSetting,
                    generalSettings: currentSettings?.generalSettings || {},
                    quoteSettings: currentSettings?.quoteSettings || {}
                }
            };
            await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`, payload);
            dispatch(updateSettings({
                typeSetting: 'invoice',
                value: invSetting
            }));
        } catch (err) {
            console.error('Failed to save purchases invoice settings:', err);
        }
    }

    if (invSettingArray.length === 0) {
        return <SettingsEmptyState title={t('setting.invoiceSettings')} />;
    }

    return (
        <div className="settings-editable-page">
            <div className='flex justify-between items-center mb-6'>
                <h1 className="text-2xl font-bold text-gray-800">{t("setting.invoiceSettings")}</h1>
                {loading ? <MwSpinnerButton /> : <MwButton
                    inGroup={true}
                    size='sm'
                    onClick={saveHandler}
                    type='saveBtn'
                >
                    {t("setting.saveChanges")}
                </MwButton>}
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {invSettingList}
            </div>
        </div>
    )
}

export default PurchasesInvoiceSettings
